import { DDI } from "callable-data-objects";
import { useField } from "formik";
import { useAccount } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";

const PresentationSelect = ({ label, ...props }: any) => {
  const [field, meta, helpers] = useField(props);
  const {
    account: { ddis },
  } = useAccount();

  if (!ddis) return <Fragment />;

  const opts = [
    {
      value: "pass-through",
      text: "Pass Through",
    },
    {
      value: "privacy",
      text: "Hide Caller ID",
    },
  ];

  ddis.forEach((ddi: DDI) => {
    opts.push({
      text: ddi.name,
      value: ddi.name,
    });
  });

  return (
    <Form.Field>
      <label>{label}</label>
      <Dropdown
        label={label}
        fluid
        search
        selection
        options={opts}
        name={field.name}
        value={field.value}
        placeholder='Select Presentation'
        onChange={(event, { value }) => {
          helpers.setValue(value);
        }}
      />
      {meta.error && (
        <Label basic color='red' pointing>
          {meta.error}
        </Label>
      )}
    </Form.Field>
  );
};

export default PresentationSelect;
